import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TelegramConnectionsModule } from '../telegram-connections/telegram-connections.module';
import { LayoutComponent } from './layout.component';
import { LayoutTabsComponent } from './layout-tabs/layout-tabs.component';
import { WorkspaceModule } from '../workspace/workspace.module';
import { LayoutsSortComponent } from './layout-sort/layouts-sort.component';
import { AngularSplitModule } from 'angular-split';
import { DevExtremeModule } from '../devextreme.module';
import { WebtraderHostMenuModule } from 'projects/webtrader/src/app/host-menu/host-menu.module';
import {ResourceEditorModule} from "../resource-editor/resource-editor.module";
import {PivotPointsPopupModule} from "../pivot-points-popup/pivot-points-popup.module";
import {QuoteGeneratorModule} from "../quote-generator/quote-generator.module";

@NgModule({
   declarations: [
      LayoutComponent,
      LayoutTabsComponent,
      LayoutsSortComponent
   ],
    imports: [
        TelegramConnectionsModule,
        CommonModule,
        AngularSplitModule,
        WorkspaceModule,
        DevExtremeModule,
        WebtraderHostMenuModule,
        ResourceEditorModule,
        PivotPointsPopupModule,
        QuoteGeneratorModule
    ],
   exports: [
      LayoutComponent,
      LayoutTabsComponent,
      LayoutsSortComponent
   ],
   providers: [],
})
export class LayoutModule { }
